/**
 * Which router the app runs under, decided in ONE place.
 *
 * In the Electron desktop shell the page is file:///…/index.html, where the
 * history API cannot work, so App.js uses HashRouter and the route lives in
 * location.hash ("#/login"). On the web it is BrowserRouter and the route is
 * location.pathname ("/login").
 *
 * Anything that reads or sets the route outside React Router must ask here.
 * api.js's 401 handler did not: it checked pathname, which under file:// is
 * the path to index.html, so it never saw "/login" and sent the window to
 * file:///login, a black screen, on every wrong password.
 */
export const USES_HASH_ROUTER =
  typeof window !== "undefined" && !!window.electronAPI;

/** The app route, e.g. "/login", under either router. */
export function currentRoute() {
  if (typeof window === "undefined") return "/";
  return USES_HASH_ROUTER
    ? window.location.hash.replace(/^#/, "") || "/"
    : window.location.pathname;
}

/**
 * Leave for the login screen with a full reload, so in-memory state (the
 * signed-in user in AuthProvider, cached queries) starts clean. Under
 * HashRouter a hash change alone would not reload: AuthProvider would still
 * hold the user, Login would bounce straight back, and the 401 would repeat.
 */
export function reloadToLogin() {
  if (USES_HASH_ROUTER) {
    window.location.hash = "#/login";
    window.location.reload();
  } else {
    window.location.href = "/login";
  }
}
